import { EditOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import React, { useMemo, useState } from 'react';
import { TdsFormItem } from '@/presentation/components/tds-form';
import { FilterArray } from '@/presentation/components/tds-form/tds-fields-filter/filter-array';
import styles from './index.module.scss';

export interface FilterPanelProps {
  entries: TdsFormItem[];
  defaultSelectedEntries: TdsFormItem[];
  onSelectedChange?: (selectedEntries: TdsFormItem[]) => void;
  style?: React.CSSProperties;
}

export const TdsFilterPanel = (props: FilterPanelProps) => {
  const { entries, defaultSelectedEntries, onSelectedChange, style } = props;
  const [visible, setVisible] = useState(false);

  const popMenu = useMemo(() => (
    <FilterArray
      entries={entries}
      defaultSelectedEntries={defaultSelectedEntries}
      onSelectedChange={(entries) => {
        onSelectedChange?.(entries);
      }}
    />
  ), [entries, defaultSelectedEntries]);

  return (
    <Popover
      visible={visible}
      onVisibleChange={visible => setVisible(visible)}
      content={popMenu}
      trigger='click'
      placement='bottom'
      destroyTooltipOnHide
      overlayClassName={styles.overlay}
    >
      <Button icon={<EditOutlined />} style={style}>编辑字段</Button>
    </Popover>
  );
};
